export default __webpack_public_path__ + "static/media/sump-pump.48f3821d.svg";